


































import { defineComponent, PropType, computed } from "@nuxtjs/composition-api";
import { useWmAttributes } from "@wemade-vsf/catalog/lib/runtime/product/composables/useWmAttributes";
import type {
    Product,
    WMProductAttribute,
} from "@wemade-vsf/catalog/lib/runtime/product/types";
import { SfHeading, SfProperty } from "@storefront-ui/vue";
import { getProductSku } from "@wemade-vsf/catalog/lib/runtime/product/getters/productGetters";

export default defineComponent({
    name: "ProductDetailsHeader",
    props: {
        product: {
            type: [Object, null] as PropType<Product>,
        },
        produktgruppe: {
            type: [Object, null] as PropType<WMProductAttribute>,
        },
    },
    components: {
        SfHeading,
        SfProperty,
    },
    setup(props) {
        const { productIdentifiers } = useWmAttributes();

        const productName = computed(() => {
            if (
                props.product?.configurable_product_options_selection?.variant
                    ?.name
            ) {
                return props.product.configurable_product_options_selection
                    .variant.name;
            }
            return props.product?.name || "";
        });

        function getPartType(label) {
            if (label.toLowerCase() === "original del") {
                return {
                    label,
                    color: "green",
                };
            }
            if (label.toLowerCase() === "økonomidel") {
                return {
                    label,
                    color: "yellow",
                };
            }

            return null;
        }

        const partType = computed(() => {
            if (props.produktgruppe) {
                return getPartType(props.produktgruppe.value);
            }

            return null;
        });

        return {
            productName,
            getProductSku,
            productIdentifiers,
            partType,
        };
    },
});
